import axios from "axios";

/**
 * Sends a GraphQL request to Shopify Storefront API
 * @param {string} query - GraphQL query string
 * @param {Object} [variables={}] - Optional GraphQL variables
 * @returns {Promise<Object>} - Shopify response data or throws error
 */
const shopifyFetch = async (query, variables = {}) => {
    try {
        const res = await axios.post(
            `https://${import.meta.env.VITE_SHOPIFY_DOMAIN}/api/${import.meta.env.VITE_STOREFRONT_API_VERSION}/graphql.json`,
            {
                query,
                variables,
            },
            {
                headers: {
                    "Content-Type": "application/json",
                    "X-Shopify-Storefront-Access-Token": import.meta.env.VITE_STOREFRONT_ACCESS_TOKEN,
                },
            }
        );

        if (res.data.errors) {
            throw new Error(JSON.stringify(res.data.errors, null, 2));
        }

        return res.data.data;
    } catch (err) {
        console.error("Shopify API error:", err.response?.data || err.message || err);
        throw err;
    }
};

export default shopifyFetch;
